import type { Ref } from "vue";
import { startStaSession } from "~/components/pages/sta";
import { get } from "lodash";

type IEvent = {
  handle: string;
  occurrences: {
    id: string;
  }[];
};

export const useManageEventCheckin = <T extends IEvent>(e?: Ref<T>) => {
  const router = useRouter();
  const { wrapLoading } = useLoading();

  const manageCheckIn = wrapLoading(async (event?: T) => {
    const $event = event || e?.value;
    if (!$event) {
      return;
    }

    const occurrenceId = get($event, "occurrences.0.id");
    if (!occurrenceId) {
      return;
    }

    const handle = String($event.handle);
    const token = await startStaSession(occurrenceId);

    router.push({
      name: "events-handle-sta",
      params: { handle },
      query: { token },
    });
  });

  return {
    manageCheckIn,
  };
};
